import classes from './CommonButton.module.css'

const CommonButton = ({title, className, style, onClick, disabled, outlined}) => {
    return(
        <button className={`d-flex align-items-center justify-content-center ${classes.wrapper} ${disabled ? classes.disabledButton : ""} ${outlined ? classes.outlinedButton : ""} ${className}`} style={style} role='button' onClick={onClick} disabled={disabled}>{title}</button>
    )
}

export default CommonButton